import { useState } from 'react';
import Lightbox from 'yet-another-react-lightbox';
import Zoom from 'yet-another-react-lightbox/plugins/zoom';
import Counter from 'yet-another-react-lightbox/plugins/counter';
import 'yet-another-react-lightbox/plugins/counter.css';

const ModalGallery = ({ images }) => {
  const [index, setIndex] = useState(-1);

  // Formatear las imágenes según la estructura requerida por la librería
  const slides = images.map((img) => ({ src: img.full, alt: img.alt }));

  const handleContextMenu = (e) => e.preventDefault();

  return (
    <>
      {/* Grid de Miniaturas dentro del modal */}
      <div className="row g-2">
        {images.map((img, i) => (
          <div key={i} className="thumb-container col-4 col-md-3">
            <img
              src={img.thumb}
              alt={img.alt}
              className="img-thumbnail img-fluid rounded cursor-pointer"
              style={{ objectFit: 'cover', height: '90px', width: '100%', cursor: 'pointer', WebkitUserSelect: 'none', userSelect: 'none' }}
              onContextMenu={handleContextMenu}
              onClick={() => setIndex(i)}
              onDragStart={(e) => e.preventDefault()}
            />
            <div className='thumbnail-front'></div>
          </div>
        ))}
      </div>

      {/* Visor Full-Screen (Lightbox) */}
      <div
        onContextMenu={(e) => e.preventDefault()}
        onDragStart={(e) => e.preventDefault()}
      >
        <Lightbox
          open={index >= 0}
          close={() => setIndex(-1)}
          index={index}
          slides={slides}
          plugins={[Zoom, Counter]}
          on={{
            click: () => {}
          }}
          styles={{
            container: {
              WebkitUserSelect: 'none',
              userSelect: 'none',
            },
            slide: {
              WebkitUserSelect: 'none',
              userSelect: 'none',
            }
          }}
        />
      </div>
    </>
  );
}

export { ModalGallery }